import { Box } from "@mui/material";
import { AssessmentOverviewCapabilityChanges } from "../overview/AssessmentOverviewCapabilityChanges";

const CapabilityChangesExport = () => {
  return (
    <Box className={"capability-changes"}>
      <AssessmentOverviewCapabilityChanges />
    </Box>
  );
};

export default CapabilityChangesExport;
